export default class Userlike {
	constructor(app) {
		this.app = app;

		//console.log("Zammad initialised!");

		document.addEventListener('cookie-allowed-convenience-userlike', (e) => {
			console.debug('userlike loading')
			let settings = {
					background: '#949493',
					fontSize: '12px',
					flat: true,
					chatId: "fr" === app.info.lang ? 1 : 3,
				}
			if (app.info.isDebug) {
				settings = {
					background: 'red',
					fontSize: '12px',
					flat: true,
					chatId: 2,
					debug: true
				}
			}

			//userlike.userlikeStartChat();
		});
	}
}
